import { createStyles } from '@mantine/core';
import { getTypographyStyles } from 'src/theme/themeConfig';

export const useStyles = createStyles((theme) => {
  const { colors } = theme.other;
  return {
    container: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#0C0C0C',
      color: '#ffffff',
    },
    header: {
      width: '100%',
      height: '44px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      backgroundColor: '#0C0C0C',
    },
    headerText: {
      fontWeight: 700,
      fontSize: '16px',
      lineHeight: '21px',
      color: '#ffffff',
      padding: '1px 16px',
    },
    contentContainer: {
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      paddingTop: '0',
      overflowY: 'scroll',

    },
    footer: {
      // display: 'flex',
      // justifyContent: 'space-between',
    },
    heading: {
      color: '#ffffff',
      marginBottom: '9px',
    },
    description: {
      fontWeight: 400,
      fontSize: '18px',
      lineHeight: '23px',
      color: '#BFBFBF',
      marginBottom: '45px',
    },
    inputWrapper: {
      width: '100%',
      fontWeight: 500,
      fontSize: '20px',
    },
    input: {
      height: '45px',
      background: '#FFFFFF1A',
      border: '0.8px solid #959EB2',
      outlineColor: '#019DE6',
      outlineWidth: '1px',
      borderRadius: '8px',
      width: '100%',
      padding: '12px 24px',
      color: '#ffffff',
    },
    inputDescription: {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '18px',
      color: '#8C8C8C',
      marginTop: '8px',
    },
    inputError: {
      color: 'red',
    },
    optionsWrapper: {
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%',
      justifyContent: 'space-between',
      marginTop: '20px',
    },
    button: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '10px 12px',
      gap: '10px',
      borderRadius: '8px',
      fontSize: '14px',
      marginBottom: '10px',
      backgroundColor: colors.base.white,
      color: colors.fg.default,
      border: `1px solid ${colors.disabled.muted}`,
      transition: '0.2s',
      position: 'relative',
      ...getTypographyStyles('heading_2xs_semibold'),
      ':hover': {
        cursor: 'pointer',
        backgroundColor: colors.primary.muted,
        color: colors.primary.default,
        border: `1px solid ${colors.primary.subtle}`,
      },
    },
    buttonSelectedAdditionalStyles: {
      cursor: 'pointer',
      backgroundColor: colors.primary.muted,
      color: colors.primary.default,
      border: `1px solid ${colors.primary.subtle}`,
    },
    smallButton: {
      width: 'calc(33% - 7px)',
    },
    mediumButton: {
      width: 'calc(50% - 5px)',
    },
    largeButton: {
      width: '100%',
    },
    backButtonWrapper: {
      position: 'absolute',
      top: 16,
      left: 16,
      zIndex: 99,
    },
    leftButton: {
      marginRight: 'auto',
    },
    rightButton: {
      float: 'right',
    },
    mb6: {
      marginBottom: '6px',
    },
    mb16: {
      marginBottom: '16px',
    },
    chargesWrapper: {
      padding: 16,
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      justifyContent: 'space-between',
      border: `1px solid ${colors.bg.muted}`,
      borderRadius: 8,
      backgroundColor: colors.bg.default,
      marginTop: 'auto',
    },
    chargesTitle: {
      borderBottom: `1px solid ${colors.bg.muted}`,
    },
    checkBoxBody: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    checkBoxLabel: {
      ...getTypographyStyles('heading_2xs_semibold'),
    },
    checkBoxRoot: {
      width: '100%',
    },
    learnMoreCta: {
      ':hover': {
        color: colors.primary.dark,
      },
    },
  };
});

export default {};
